import { combineComponents } from "../utility/combineComponents";
import { BetaContextProvider } from "./Beta";

const providers = [BetaContextProvider];
export const AppContextProvider = combineComponents(...providers);
